/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;min-height:100vh;align-items:center;display:flex;justify-content:center;flex-direction:column;background:#2c373c;padding:1em}.logo[_ngcontent-%COMP%]{height:64px;margin:0 0 15px}.box[_ngcontent-%COMP%]{width:100%;max-width:360px;justify-content:center;align-items:center;flex-direction:column;display:flex;padding:30px;background:#fafafa}h1[_ngcontent-%COMP%]{margin:0 0 15px;position:relative;top:-15px;font-size:1.4em;font-weight:400}"];
export { styles as styles };
